module.exports = __webpack_public_path__ + "static/media/2017.ATC.Son.Protego.39f4c035.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/2017.ATC.Son.Protego.pdf
// module id = 61
// module chunks = 0